import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IPaginatedResponse } from '../../interfaces/api/responses.interface';

@Injectable({
  providedIn: 'root',
})
export class VacationService {
  private apiUrl = `${environment.apiUrl}/solicitudes`;

  constructor(private http: HttpClient) {}

  postSolicitudesByCompany(filter: Record<string, unknown>): Observable<IPaginatedResponse<any>> {
    return this.http.post<IPaginatedResponse<any>>(
      this.apiUrl + '/listSolicitudeByCompany',
      filter
    );
  }

  createVacation(data: FormData): Observable<any> {
    return this.http.post<any>(this.apiUrl + '/registerSolicitudeVacation', data);
  }

  updateVacation(data: FormData): Observable<any> {
    return this.http.post<any>(this.apiUrl + '/updateSolicitudeVacation', data);
  }

  postGeneratePDF(data: any): Observable<any> {
    return this.http.post<any>(this.apiUrl + '/generatorPdf', data);
  }
}
